import { SingleQuestion } from 'app/components/questions/single'
import { genericChangeCTA } from 'app/containers/PipelineSection/Expenses'
import * as React from 'react'

const GroceriesQuestionsGroup = () => (
  <SingleQuestion
    header="Groceries"
    icon="fa fa-fw fa-cutlery"
    headerDescription="In this section, you'll be entering your grocery expenses."
    question={{
      placeholder: 'Enter your current monthly grocery expenses',
      name: 'expenses.groceries.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your monthly grocery expenses during retirement',
        name: 'expenses.groceries.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

const DiningOutQuestionsGroup = () => (
  <SingleQuestion
    header="Dining out"
    icon="fa fa-fw fa-cutlery"
    headerDescription="In this section, you'll be entering your expenses for dining out."
    question={{
      placeholder: 'Enter your current monthly dining out expenses',
      name: 'expenses.diningOut.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your monthly dining out expenses during retirement',
        name: 'expenses.diningOut.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

export {
  GroceriesQuestionsGroup,
  DiningOutQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Food/index.tsx